<template>
<div class="buttons">
    <div class="button-row">
        <!-- <button v-for="(val, index) in ButtonValues" v-bind:class="{index: true}" :key="index" @click.prevent="handleButtonSelect(val)">{{ val }}</button> -->
        <button :class="ButtonClass_0" @click.prevent="handleButtonSelect(ButtonValues[0])">{{ ButtonValues[0] }}</button>
        <button :class="ButtonClass_1" @click.prevent="handleButtonSelect(ButtonValues[1])">{{ ButtonValues[1] }}</button>
        <button :class="ButtonClass_2" @click.prevent="handleButtonSelect(ButtonValues[2])">{{ ButtonValues[2] }}</button>
        <button :class="ButtonClass_3" @click.prevent="handleButtonSelect(ButtonValues[3])">{{ ButtonValues[3] }}</button>
    </div>
</div>
</template>

<script>
import EventBus from '@/EventBus.js';

export default {
    name: 'button-stage',
    data() {
        return {
            levenshtein_distance: 5,
            selectedButtonValue: 0,
            animateClass: '',
            isClickable: true
        }
    },
    computed: {
        ButtonValues() {
            if (this.levenshtein_distance > 0) {
                return this.getButtonValues(this.levenshtein_distance);
            }
            return ['?','?','?','?'];
        },
        ButtonClass_0() {
            if (this.selectedButtonValue == this.ButtonValues[0]) {
                return this.animateClass;
            }
            return '';
        },
        ButtonClass_1() {
            if (this.selectedButtonValue == this.ButtonValues[1]) {
                return this.animateClass;
            }
            return '';
        },
        ButtonClass_2() {
            if (this.selectedButtonValue == this.ButtonValues[2]) {
                return this.animateClass;
            }
            return '';
        },
        ButtonClass_3() {
            if (this.selectedButtonValue == this.ButtonValues[3]) {
                return this.animateClass;
            }
            return '';
        }
    },
    methods: {
        removeAnimationClass() {
            this.animateClass = '';
            this.isClickable = true;
        },
        handleButtonSelect(value) {
            if (value === '?' || ! this.isClickable) return;

            this.isClickable = false;
            this.selectedButtonValue = value;
            if (value === this.levenshtein_distance) {
                this.animateClass = 'correct';
                EventBus.dispatch('on-correct-choice');
            } else {
                this.animateClass = 'wrong';
                EventBus.dispatch('on-wrong-choice');
            }
            window.setTimeout(this.removeAnimationClass, 600);
        },
        /**
         * a new word pair was found
         * @param {int} the levenshtein distance
         */
        handleNewLevenshteinDistance(distance) {
            this.levenshtein_distance = distance;            
        },
        /**
         * get Button Values based on a "base" Value
         * @param {int} base
         * @return {array}
         */
        getButtonValues(base) {
            if (base <= 4) {
                return [1,2,3,4];
            }

            let result = [];
            // Pad the array to the left
            for (let minus = base - 1; minus > base - 4; minus--) {
                result.push(minus);
            }

            // add correct value "in the middle"
            result.push(base);

            // Pad the array to the right
            for (let plus = base + 1; plus < base + 4; plus++) {
                result.push(plus);
            }

            // Sort the array as integers!
            result.sort((a,b) => {
                if (a > b) return 1;
                if (a < b) return -1;
                return 0;
            });
            let randomStart = Math.floor(Math.random() * (result.length - 3));
            // Take a slice of our created array
            let arr = result.slice(randomStart, randomStart + 4);
            return arr;
        }
    },
    mounted() {
        EventBus.on('new-levenshtein-distance', this.handleNewLevenshteinDistance);
    }
}
</script>

<style lang="scss">
.buttons {
    background:url("../assets/dark-stage.png") top center no-repeat;
    width: 100%;
    position: relative;
    height: calc(100% / 3.4);

    &>img {
        max-width:100%;
        height: auto;
        position: absolute;
        left:0;
        bottom:0;
        z-index:0;
    }

    .button-row {
        display: flex;
        flex-direction: row;
        flex-wrap:nowrap;
        justify-content: space-around;
        align-items: center;
        position: relative;
        z-index: 100;
        height:100%;
        width:90%;
        margin:0 auto;
     
        button {
            width: 60px;
            height: 60px;
            border-radius: 12px 12px;
            background-color: #fff;
            text-align: center;
            vertical-align: middle;
            border-collapse: collapse;
            border:none;
            font-size: 36px;
            font-family: 'Oswald-Light';
            cursor:pointer;

            &:focus {
                outline:none;
            }

            &.wrong {
                border:2px solid darken(#B21D1D, 30%);
                background: #B21D1D;
                color:rgba(255, 255, 255, 0.75);
                cursor:auto;
            }
            &.correct {
                border:2px solid darken(#79c641, 30%);
                background: #79c641;
                color:rgba(255, 255, 255, 0.75);
                cursor:auto;
            }


            @media (min-width:474px) {
                width: 90px;
                height: 90px;
                border-radius: 30px 30px;
            }
        }
    }  
}
</style>
